import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import QueryProviders from './state/query-client';
import { LanguageProvider } from './i18n/language-context';
import './i18n/i18n';
import { AppRoutes } from './routes/app-routes';
import { RouteErrorPage } from './modules/error-view';
import { OverflowTooltip } from './components/core/overflow-tooltip/overflow-tooltip';

/**
 * A single catch-all data route hosting the existing `<Routes>` tree. This gives us
 * `useBlocker` (needed for the unsaved-changes navigation guard) without touching the
 * route definitions themselves — `element` mounts once and re-renders per URL, same as
 * the plain `<BrowserRouter>` it replaces.
 */
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <QueryProviders>
        <LanguageProvider defaultLanguage="en-US" defaultModules={['generic']}>
          <AppRoutes />
        </LanguageProvider>
      </QueryProviders>
    ),
    errorElement: <RouteErrorPage />,
  },
]);

export default function App() {
  return (
    <>
      <RouterProvider router={router} />
      <OverflowTooltip />
    </>
  );
}
